import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import SuppliersList from "./SuppliersList";
import styles from "../Settings.module.scss";
import EditSupplierCategory from "./EditSupplierCategory";
import { toast } from "react-toastify";
import {
  addSupplierCategory,
  getSupplierCategories,
  updateSupplierCategory,
} from "../../../services/supplierCategoryService";

const SupplierCategories = (props) => {
  const [showForm, setShowForm] = React.useState(false);
  const [editItem, setEditItem] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [supplierCategories, setSupplierCategories] = React.useState([]);

  const closeForm = () => {
    setShowForm(false);
    if (editItem) setEditItem();
  };

  const fetchData = async () => {
    setLoading(true);
    const data = await getSupplierCategories();
    setSupplierCategories(data);
    setLoading(false);
  };

  const enterEdit = (item) => {
    if (!item?.id) {
      console.error("Missing item.id for edit:", item);
      return;
    }
    setShowForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (formData) => {
    try {
      if (editItem) {
        await updateSupplierCategory(formData.id, formData);
        toast.success("Supplier Category Updated");
        setEditItem();
      } else {
        await addSupplierCategory(formData);
        toast.success("Supplier Category Added");
      }
      closeForm();
      await fetchData();
    } catch (error) {
      console.error(error);
      toast.error("Error occurred while adding Supplier Category");
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="d-flex flex-column h-100 w-100">
      <div className="d-flex ms-auto mb-3 flex-shrink-0">
        <Button
          className={`common-btn`}
          onClick={() => {
            setShowForm(true);
            props.open?.();
          }}
        >
          Add Supplier Category
        </Button>
      </div>

      <div className="flex-grow-1 settings-grid-wrapper overflow-auto mb-2" style={{ minHeight: 0 }}>
        <SuppliersList
          supplierCategories={supplierCategories}
          loading={loading}
          enterEdit={enterEdit}
        />
      </div>

      {showForm && (
        <EditSupplierCategory
          cancelEdit={closeForm}
          onSubmit={handleSubmit}
          editItem={editItem}
        />
      )}
    </div>
  );
};

export default SupplierCategories;
